import Component from '../abstracts/Component';
import RecommendationEngineLogic from "../logics/RecommendationEngineLogic";

export default class GoogleRecommendationEngineComponent extends Component {

  get SELECTORS() {
    return {
      recommendationEngineProductsContainer: '#google-recommendation-engine-products-container',
      carouselCards: '#carouselCards',
      wishlistButton: "[data-js-wishlist]",
      prevArrow: "[data-prev-arrow]",
      nextArrow: "[data-next-arrow]",
      carouselTitleModel: '#googleRecommendationModel',
      carouselTitle: '#google-recommendation-title',
      carouselChildrenSelector: ".c-product-card"
    };
  }

  get CONSTANTS() {
    return {
      RECOMMENDATION_ENGINE_URL: "/action/recommendation-google",
      GET: "GET",
      POST: "POST",
      CHECKOUT_TEMPLATE: "t-checkout-confirm"
    };
  }

  constructor(compEl) {
    super(compEl);
    new RecommendationEngineLogic(compEl, this.SELECTORS, this.CONSTANTS).render();
  }
}
